import ApiService from '../services/api';
import ActionTemplate from './services/actionTemplate';

const REQUEST_HPP_LINK = 'REQUEST_HPP_LINK';

/** Actions for CreateSession */
export default class CreateSessionAction {

    constructor() {
        this.api = new ApiService();
        this.actionTemplate = new ActionTemplate();
    }

    requestHPPLink(transactionId, surcharge, cardType){
        return (dispatch) => {
            dispatch(this.actionTemplate.request(REQUEST_HPP_LINK));
            const url = `https://api.corelogic.asia/mulesoft/payments_ui/session?transactionId=${transactionId}&amountSurcharge=${surcharge}&payCode=${cardType}`;

            return fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    return response.json();
                })
                .then((data) => {
                    dispatch(this.actionTemplate.success(REQUEST_HPP_LINK, data));
                    return data;
                })
                .catch((error) => {
                    dispatch(this.actionTemplate.failure(REQUEST_HPP_LINK, error.message));
                    throw error;
                });
        };
    }
    
}
